import { z } from 'zod';

import { CatalogItemStatusSchema } from '../services/catalog-item-status.schema.js';

export const AddProductImageBodySchema = z.object({
  imageUrl: z.url(),
  sortOrder: z.number().int().nonnegative().optional(),
});

export const AddProductImageResponseSchema = z.object({
  imageId: z.uuid(),
});

export const ReorderProductImageBodySchema = z.object({
  sortOrder: z.number().int().nonnegative(),
});

export const ProductImageListItemSchema = z.object({
  id: z.uuid(),
  imageUrl: z.url(),
  sortOrder: z.number().int().nonnegative(),
});

export const ListProductImagesResponseSchema = z.object({
  items: z.array(ProductImageListItemSchema),
});

export const LinkProductSimilarBodySchema = z.object({
  similarProductId: z.uuid(),
});

export const LinkComplementaryProductBodySchema = z.discriminatedUnion('targetKind', [
  z.object({
    targetKind: z.literal('PRODUCT'),
    complementaryProductId: z.uuid(),
  }),
  z.object({
    targetKind: z.literal('GENERIC'),
    catalogGenericProductId: z.uuid(),
  }),
]);

export const ComplementaryProductListItemSchema = z.discriminatedUnion('targetKind', [
  z.object({
    targetKind: z.literal('PRODUCT'),
    linkId: z.uuid(),
    id: z.uuid(),
    name: z.string(),
    status: CatalogItemStatusSchema,
    sku: z.string().nullable().optional(),
    manufacturerName: z.string().nullable().optional(),
    manufacturerCode: z.string().nullable().optional(),
  }),
  z.object({
    targetKind: z.literal('GENERIC'),
    linkId: z.uuid(),
    id: z.uuid(),
    name: z.string(),
  }),
]);

export const ListComplementaryProductsResponseSchema = z.object({
  items: z.array(ComplementaryProductListItemSchema),
});

export const LinkComplementaryServiceBodySchema = z.object({
  tenantServiceId: z.uuid(),
});

export const ProductRelationPreviewSchema = z.object({
  linkId: z.uuid(),
  id: z.uuid(),
  name: z.string(),
  status: CatalogItemStatusSchema,
  sku: z.string().nullable().optional(),
  manufacturerName: z.string().nullable().optional(),
  manufacturerCode: z.string().nullable().optional(),
  origin: z.enum(['MANUAL', 'DERIVED']).optional(),
});

export const ListProductRelationPreviewResponseSchema = z.object({
  items: z.array(ProductRelationPreviewSchema),
});

export const ServiceRelationPreviewSchema = z.object({
  linkId: z.uuid(),
  id: z.uuid(),
  name: z.string(),
  status: CatalogItemStatusSchema,
});

export const ListServiceRelationPreviewResponseSchema = z.object({
  items: z.array(ServiceRelationPreviewSchema),
});

export type AddProductImageBody = z.infer<typeof AddProductImageBodySchema>;
export type AddProductImageResponse = z.infer<typeof AddProductImageResponseSchema>;
export type ReorderProductImageBody = z.infer<typeof ReorderProductImageBodySchema>;
export type ListProductImagesResponse = z.infer<typeof ListProductImagesResponseSchema>;
export type LinkProductSimilarBody = z.infer<typeof LinkProductSimilarBodySchema>;
export type LinkComplementaryProductBody = z.infer<typeof LinkComplementaryProductBodySchema>;
export type ComplementaryProductListItem = z.infer<typeof ComplementaryProductListItemSchema>;
export type ListComplementaryProductsResponse = z.infer<
  typeof ListComplementaryProductsResponseSchema
>;
export type LinkComplementaryServiceBody = z.infer<typeof LinkComplementaryServiceBodySchema>;
export type ListProductRelationPreviewResponse = z.infer<
  typeof ListProductRelationPreviewResponseSchema
>;
export type ListServiceRelationPreviewResponse = z.infer<
  typeof ListServiceRelationPreviewResponseSchema
>;
